<template>
        <div class="location-filters">
            <div class="container">
                <div class="location-filters__filter">
                    <div class="location-filters__filter-dropdown" @click="toggleDropdown">
                        <span>{{ activeRegion !== null ? activeRegion : 'Filter'}}</span>
                        <i :class="{ 'icon-chevron-down': !showDropdown, 'icon-chevron-up': showDropdown }"></i>
                    </div>   
                </div>
                <p class="location-filters__count-desktop">Showing all {{ activeLocationCount }} results</p>
                <div class="location-filters__filter-desktop">
                    <p>Filter by</p>
                    <button class="locations__filter-button" :class="{
                        'locations__filter-button--active': activeRegion === region
                    }" v-for="region in regions" :key="region" @click="$emit('toggle-region', region)">
                        {{ region }}
                    </button>
                </div>
                <div class="location-filters__display">
                    <button 
                        title="Display Map" 
                        class="location-filters__display-button" 
                        :class="{
                            'location-filters__display-button--active': display === 'map'
                        }"
                        @click="$emit('toggle-display', 'map')"
                    >
                        <i class="icon-map-marker"></i>
                    </button>
                    <button 
                        title="Display Grid" 
                        class="location-filters__display-button" 
                        :class="{
                            'location-filters__display-button--active': display === 'grid'
                        }"
                        @click="$emit('toggle-display', 'grid')"
                    >
                        <i class="icon-grid"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="location-filters__filter-dropdown-content" v-show="showDropdown">
                <button 
                    class="locations__filter-button" 
                    :class="{
                        'locations__filter-button--active': activeRegion === region
                    }" 
                    v-for="region in regions" 
                    :key="region" 
                    @click="$emit('toggle-region', region)"
                >
                    {{ region }} 
                </button>
        </div>
</template>

<script>
export default {
    props: ["locations", "display", "activeRegion","activeLocationCount"],
    data() {
        return {
            showDropdown: false,
            regions: [],
            activeLocations: []
        }
    },
    methods: {
        toggleDropdown: function () {
            this.showDropdown = !this.showDropdown
        }
    },
    watch: {
        locations: function () {
            let regions = [];
            this.locations.forEach((location) => {
                if (!regions.includes(location.region)) {
                    regions.push(location.region)
                }
            });
            this.regions = regions;
            this.activeLocations = this.locations
        }
    }
}
</script>

